// extracted by mini-css-extract-plugin
export var clarsyntCategoryCard = "category-card-module--clarsynt-category-card--3O7It";